import { SelfDescribingJson } from '@snowplow/tracker-core';
import { GeniallyContext } from '../contexts/GeniallyContext';
import { truncateDataToMaxLength } from '../utils/truncateDataToMaxLength';

export const mapGeniallyContext = (
  genially: GeniallyContext,
): SelfDescribingJson<Record<string, unknown>> => {
  const {
    id: genially_id,
    name,
    isPublished: is_published,
    isReusable: is_reusable,
    hasPassword: has_password,
    hasScroll: has_scroll,
    hasInternalAnalytics: has_internal_analytics,
    hasUserTracking: has_user_tracking,
    isPrivate: is_private,
    isInSocialProfile: is_in_social_profile,
    isInspiration: is_inspiration,
    hasChangesWaitingToBePublished: has_unpublished_changes,
  } = genially;

  return {
    schema: 'iglu:com.genially/genially/jsonschema/2-3-0',
    data: {
      genially_id,
      name: truncateDataToMaxLength(name),
      is_published,
      is_reusable,
      has_password,
      has_internal_analytics,
      has_user_tracking,
      has_scroll,
      is_private,
      is_in_social_profile,
      is_inspiration,
      has_unpublished_changes,
    },
  };
};
